import React from 'react';
import {Datagrid, DateField, Filter, List, TextField, TextInput} from 'react-admin';

const AttendanceDetailsChangedHistoryFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const AttendanceDetailsChangedHistoryList = props => (
    <List filters={<AttendanceDetailsChangedHistoryFilter/>} bulkActionButtons={false} {...props} exporter={false}>
        <Datagrid rowClick={false}>
            <TextField source="id"/>
            <TextField source="changedObjId"/>
            <TextField source="customerId"/>
            <TextField source="customerName"/>

            <TextField source="lastUpdatedBy"/>
            <DateField source="changedDateTime" showTime/>
            <TextField source="displayOldStt"/>
            <TextField source="displayNewStt"/>
        </Datagrid>
    </List>
);

export default AttendanceDetailsChangedHistoryList
